import { Animated, Platform } from 'react-native';
export var updateThumb = (fadeAnim, toggleState, size) => {
  var thumbBtnWidth = size / 2;
  var trackBarW = size;
  var distance = trackBarW - thumbBtnWidth - 4;
  var toValue = toggleState ? distance : 0;
  Animated.timing(fadeAnim, {
    toValue,
    duration: 200,
    useNativeDriver: Platform.OS !== 'web'
  }).start();
};